const initialState = {
    practiceTests: 0,
    mockTests: 0,
    completed: 0
};

export default (state = initialState, action = {}) => {
    if (action.type === 'GET_QUIZ_TYPE_COUNT') {
        return {
            ...action.payload
        };
    }
    return state;
};
